unit SMX.Auth.Shared;

interface

uses
  Sphinx.Consts;

{$SCOPEDENUMS ON}

(*
{
    "ClientId": "GAMTWeb",
    "TokenType": "access_token",
    "ExpiresIn": "7200",
    "Claims": [{
            "Name": "exp",
            "Value": "1714479770"
        }, {
            "Name": "iat",
            "Value": "1714472570"
        }, {
            "Name": "jti",
            "Value": "e0089eca-a994-4d9a-b1de-0f4fdd3bbe21"
        }, {
            "Name": "sub",
            "Value": "3a0cbdcf-213b-41f1-8819-2bc14ae950fa"
        }, {
            "Name": "iss",
            "Value": "http://localhost:2018/GASphinx"
        }, {
            "Name": "client_id",
            "Value": "GAMTWeb"
        }, ]
}

{
    "ClientId": "GAMTWeb",
    "TokenType": "id_token",
    "ExpiresIn": "300",
    "Claims": [{
            "Name": "email_verified",
            "Value": "True"
        }, {
            "Name": "sub",
            "Value": "3a0cbdcf-213b-41f1-8819-2bc14ae950fa"
        }, {
            "Name": "jti",
            "Value": "c57cdd8b-cf6b-41bc-97c5-5c60866dc154"
        }, {
            "Name": "email",
            "Value": "russell@weetch.com"
        }, {
            "Name": "iss",
            "Value": "http://localhost:2018/GASphinx"
        }, {
            "Name": "aud",
            "Value": "GAMTWeb"
        }, {
            "Name": "exp",
            "Value": "1714472944"
        }, {
            "Name": "iat",
            "Value": "1714472644"
        }, {
            "Name": "nonce",
            "Value": "TYe6yCL6_RTatKahl5Jp5SCTWVRtEyThOqPSv-GJzJ8"
        }, ]
}

*)


{$IFDEF PAS2JS}
type
  TUserScope = (None, HMRCOnly, readonly, User, AdminUser, Administrator, SuperUser);
{$ENDIF}

const
  CLAIM_FIRSTNAME = JwtClaimNames.GivenName; // 'given_name';
  CLAIM_LASTNAME = JwtClaimNames.FamilyName;
  CLAIM_FULLNAME = JwtClaimNames.Name; // 'name';

  CLAIM_USER_INTERNAL_ID = 'user-internal-id';
  CLAIM_USERID = 'uid';
  CLAIM_PERSONID = 'person-id';
  CLAIM_LOCATIONTYPE = 'locationtype';
  CLAIM_SCOPE = 'scope';
  CLAIM_ROLE = 'role';
  CLAIM_TENANT_ID = 'tenant-id';  //DO NOT CHANGE THIS IS USED BY XData!!!//
  CLAIM_ORGANISATION_ID = 'org-id';
  CLAIM_ORGANISATION_NAME = 'org-name';
  CLAIM_AGENT_NAME = 'agent-name';
  CLAIM_ORGANISATION_TENANT_ID = 'org-tenant-id';
  CLAIM_ORGANISATION_KIND = 'org-kind';
  CLAIM_AGENT_ID = 'agent-id';
  /// <summary>OAuth client identifier claim in access tokens from Sphinx.</summary>
  CLAIM_CLIENT_ID = 'client_id';

  /// <summary>Sphinx client app id for cross-tenant API administration (tokens use org-id 0).</summary>
  API_ADMIN_CLIENT_APP_ID = 'GAMTApiAdmin';

  /// <summary>Sphinx server client used for GA-API cache calls to Sphinx (see EnsureDefaultAPIClientApps).</summary>
  API_CACHE_CLIENT_APP_ID = 'GAMTApiCache';

  // Canonical tenant-scoped signing key naming:
  //   <tenant-id>-SIGNING-KEY
  TENANT_SIGNING_KEY_SUFFIX = '-SIGNING-KEY';
  TENANT_SIGNING_KEY_PATTERN = '<tenant-id>' + TENANT_SIGNING_KEY_SUFFIX;

  /// <summary>
  ///   JWT kid for tokens signed while the user has no tenant yet (registration / setup).
  ///   Signing material is resolved via GetSphinxRegistrationJwtSigningKey, not GetSigningKeyByKeyId.
  ///   When the secret store is off and RegistrationJwtSigningKey is unset, that helper falls back
  ///   to [Sphinx] SigningKey (same legacy shared key as tenant *-SIGNING-KEY resolution).
  /// </summary>
  REGISTRATION_SIGNING_KEY_ID = 'GA-REGISTRATION-SIGNING-KEY';

  ORGANISATION_NOT_CREATED = 'not-created';
  ORGANISATION_SETUP_PENDING = 'setup-pending';
  ORGANISATION_MULTI_TENANT = 'multi-tenant';

  /// <summary>
  /// Platform / SMXi support organisation. Users on this tenant must not act as
  /// tenant members, HMRC officials, or claim signers.
  /// </summary>
  SMXI_ADMIN_TENANT_ID = 'smxi-admin';

  HEADER_TENANT_ID = 'tenant-id';

  //This is added to the Id Token by Sphinx as "email"
  CLAIM_EMAIL = 'email';

  SCOPE_NONE = 'None';
  SCOPE_HMRC_ONLY = 'HMRCOnly';
  SCOPE_READ_ONLY = 'ReadOnly';
  SCOPE_USER = 'User';
  SCOPE_ADMIN_USER = 'AdminUser';
  SCOPE_ADMIN = 'Administrator';
  SCOPE_SUPERUSER = 'SuperUser';

implementation

{$SCOPEDENUMS OFF}

end.
